import cappuccino from "../media/cappucino.jpg";
import expresso from "../media/expresso.jpg";
import latte from "../media/latte.jpg";
import affogato from "../media/affogato.jpeg";
import icecoffee from "../media/icecoffee.jpg";
import turkish from "../media/turkish.jpg";

export const MenuList = [
  {
    name: "Cappuccino",
    image: cappuccino,
    price: 15.99,
  },
  {
    name: "Expresso",
    image: expresso,
    price: 11.99,
  },
  {
    name: "Latte",
    image: latte,
    price: 256.53,
  },
  {
    name: "Affogato",
    image: affogato,
    price: 17.99,
  },
  {
    name: "Ice Coffee",
    image: icecoffee,
    price: 4.99,
  },
  {
    name: "Turkish Coffee",
    image: turkish,
    price: 1997.99,
  },
];
